import { Box, Typography, TextField, FormLabel, Button } from "@mui/material";
import Logo from "../../assets/landing_page/Planshare.png";
export const ChangePassword = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        backgroundImage: `url('./background_1.jpg')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: "rgba(255, 255, 255, 0.3)", // White overlay with 50% opacity
    backgroundBlendMode: "overlay",
      }}
    >
      <Box
        sx={{
          height: "75vh",
          width: "27%",
          border: "1px solid #E7E8EA",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          background: "#FFFFFF",
          borderRadius: "12px",
          p: "40px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
                src={Logo}
                alt='planshare logo'
                onClick={()=>(window.location.href = "https://planshare.ai")}
                style={{ width: "140px", height: "32px", cursor: "pointer" }}
              />
          </Box>
        <Typography
          sx={{
            my: 1,
            fontWeight: "600",
            fontSize: "20px",
            color: "#040815",
          }}
        >
          Change Password ✨
        </Typography>
        <Typography
          sx={{ fontWeight: "500", fontSize: "16px", color: "#47474799" }}
        >
          We have just sent a verification code to you mail.
        </Typography>
        <Box
          sx={{
            my: 2,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}
          >
            Enter Code
          </FormLabel>
          <TextField
            placeholder="Enter Code"
            sx={{
              my: 1,
              "& input": {
                height: "10px",
              },
            }}
          ></TextField>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Typography
              sx={{
                textDecoration: "none",
                fontWeight: "500",
                fontSize: "12px",
                color: "#040815",
              }}
            >
              Resend Code?
            </Typography>
          </Box>
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}
          >
            Password
          </FormLabel>
          <TextField
            placeholder="Enter Password"
            sx={{
              my: 1,
              "& input": {
                height: "10px",
              },
            }}
          ></TextField>
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}
          >
            Re-Enter Password
          </FormLabel>
          <TextField
            placeholder="Re-Enter Password"
            sx={{
              my: 2,
              "& input": {
                height: "10px",
              },
            }}
          ></TextField>
          <Button
            sx={{
              background: "#FF2800",
              color: "#FFFFFF",
              textTransform: "capitalize",
              fontSize: "14px",
              fontWeight: "600",
              "&:hover": {
                background: "#e64a19",
              },
            }}
          >
            Change Password
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
